import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PktrAppMenuService } from '@prospektr/pktr-app-menu';
import { } from 'events';
import moment from 'moment';
import { SwiperComponent } from 'ngx-swiper-wrapper';
import { Observable, Subject, Subscription, combineLatest } from 'rxjs';
import { filter, finalize, takeUntil } from 'rxjs/operators';
import { ProspektrApi } from 'src/app/_shared/api/prospektr.api';
import { SubscriptionState } from 'src/app/_shared/state/subscription.state';
import { MainMenuComponent } from 'src/app/navigation/main-menu/main-menu.component';
import { NotificationService } from 'src/app/notifications/service/notification.service';
import { NotificationState } from 'src/app/notifications/state/notification.state';
import { ReportsService } from 'src/app/reports/reports.service';
import { ReportsState } from 'src/app/reports/reports.state';
import { AppNotification, SocketService } from 'src/app/shared/service/socket/socket.service';
import { PropertyState } from 'src/app/workspace/state/property.state';
import constants from 'src/constant.json';
import { AuthorizeService } from '../../_core/access-control/authorize.service';
import { SwiperConfig } from '../../_shared/config/swiper.config';
import { UserState } from '../../_shared/state/user.state';
import { AppState } from '../../app.state';
import { LocalStorageService } from '../../shared/service/local-storage.service';
import { SubscriptionPlanService } from '../../shared/service/subscription-plan.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit, OnDestroy {
  mobileQuery: MediaQueryList;
  private readonly mobileQueryListener = (
    event: MediaQueryListEvent
  ): void => {
    this.cdr.detectChanges();
  };
  @Input() isProfilePicUpdated: Observable<boolean>;
  @Input() isProfileUpdated: Observable<boolean>;
  @Output() navEvent: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('planUpdateDialog', { static: true }) planUpdateDialog: any;

  notificationCount = 0;
  notificationData: any[] = [];
  businessAreaAlertStatus = 0;
  mlsAlertStatus = 0;
  unreadNotificationCount = 0;

  userContact: any;
  userProfileImg: any;
  userName: string;
  showAllNavigation = false;
  planExpiryDate: any;
  isTrial: boolean;
  isLandingPlan: boolean;
  showUpgrade: boolean;
  planExpired: boolean;
  hideLogOutSection: boolean;
  isHamburger: boolean = true;
  canUpgradePlan = false;
  websiteUrl: string;
  canViewInvestor: boolean;
  canViewProfile: boolean;
  isSingleBranded = false;
  isSliderDisabled = true;
  isCompanyLogoExist = true;
  viewSignIn = true;
  brandingInfo = [];
  clientDarkLogo = null;
  constant: any = constants;
  defaultProfileImage = constants.userAvatar;
  companyDetails: object = {};
  companyLogo: any;
  userType: string = '';
  companyName: string = '';
  signUpUrl: string = '/signup/';
  userRole: string;
  upgradeSnackbar: MatSnackBarRef<any>;
  isDefaultLoanOfficer: boolean = false;
  isDefaultAgent: boolean = false;
  enableChatBot: boolean = false;
  chatBotName: string = 'Rhea';
  dialogRef: any;
  message: string;
  showModifySearchButton: boolean = false;
  maxUsageLimit: number | null = null;
  alreadyUsedLimit: number = 0;
  planStats: any;
  showInvestSell: boolean = false;
  // Subject used to unsubscribe Subscriptions on OnDestroy
  private onDestroyNotifier$ = new Subject();

  // Subscription for unsubscribing on OnDestroy
  private initialLoginSub$ = new Subscription();
  private alertList$: Subscription = new Subscription();
  private alertListCount$: Subscription = new Subscription();
  private planUsage$: Subscription = new Subscription();

  @ViewChild(SwiperComponent) swiperCompRef?: SwiperComponent;
  @ViewChild(MainMenuComponent) mainMenu: MainMenuComponent;
  displayInfo: boolean = false;
  hideAttributes: boolean = false;
  pathsToHideAttributes = ['/verifyAccount', '/signup/continue', 'signup', 'login', 'get-started'];
  showInvest: boolean = false;


  constructor(
    media: MediaMatcher,
    public router: Router,
    private storage: LocalStorageService,
    private subscriptionService: SubscriptionPlanService,
    public appState: AppState,
    private authorizeService: AuthorizeService,
    public swiperConfig: SwiperConfig,
    public userState: UserState,
    private notificationState: NotificationState,
    private notificationService: NotificationService,
    private subscriptionState: SubscriptionState,
    public prospektrApi: ProspektrApi,
    public reportsState: ReportsState,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    public propertyState: PropertyState,
    private reportsService: ReportsService,
    private cdr: ChangeDetectorRef,
    private socketService: SocketService,
    private activatedRoute: ActivatedRoute,
    public _pktrAppMenuService: PktrAppMenuService,
  ) {
    this.mobileQuery = media.matchMedia(
      '(max-width: 767.98px)'
    );

    this.mobileQuery.addEventListener(
      'change',
      this.mobileQueryListener
    );
  }

  ngAfterViewInit() {
    if (this.mainMenu) {
      this.mainMenu.initStart();
    }
  }

  ngOnInit() {
    this.notificationService.initializeRealtimeNotifications();

    this.appState.authToken$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (!res?.accessToken) return;
      this.reportsService.getPlanStatus();
      this.subscriptionService.getSubscriptionPlan();
    });

    this.appState.clientInfo$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      this.clientDarkLogo = res.client.logo.dark;
    });
    this.canViewInvestor = this.authorizeService.canView('clientBranding');
    this.canUpgradePlan = this.authorizeService.canView('planUpgrade');
    this.canViewProfile = this.authorizeService.canView('profile');

    combineLatest([this.userState.userDetail$, this.appState.companyInfo$])
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(([userInfo, companyInfo]) => {
        if (companyInfo && companyInfo?.appConfig?.myListings?.isEnabled) {
          if (window.location.pathname.includes('/listMyHome')) {
            this.showInvestSell = false;
            this.showInvest = true;
          }

          if (!window.location.pathname.includes('/listMyHome')) {
            this.showInvestSell = true;
            this.showInvest = false;
          }

        } else {
          this.showInvestSell = false;
          this.showInvest = false;
        }
        if (userInfo?.roles?.length > 0) {
          this.userRole = userInfo.roles[0];
          if (this.userRole != 'investor') this.showInvestSell = false;
        }

        const currentView = this.mobileQuery.matches ? 'mobile' : 'desktop';
        const userSession = userInfo ? 'identified' : 'guest';

        if (
          companyInfo?.alias &&
          companyInfo?.customizationConfig?.companyNavBar?.length &&
          companyInfo?.customizationConfig?.companyNavBar[0]?.activeView.includes(currentView) &&
          companyInfo?.customizationConfig?.companyNavBar[0]?.sessionStatus.includes(userSession) &&
          companyInfo?.customizationConfig?.companyNavBar[0]?.config?.active
        ) {
          if (companyInfo?.customizationConfig?.companyNavBar[0]?.config?.hasLogo) this.isCompanyLogoExist = false;
          if (companyInfo?.customizationConfig?.companyNavBar[0]?.config?.hasLogIn) this.viewSignIn = false;
          if (companyInfo?.customizationConfig?.companyNavBar[0]?.config?.showMenu) this.isHamburger = true;
          else this.isHamburger = false;
        } else {
          this.isHamburger = true;
        }
        if (!this.userState.userDetails?.user_profile) {
          this.isHamburger = false;
        }
        this.websiteUrl = companyInfo?.websiteUrl;
        this.signUpUrl = `/signup/${companyInfo?.signUpId ?? ''}`;
        this.hideLogOutSection = companyInfo?.isTokenAuthEnabled || false;
        this.userType = this.userState.userDetails?.userType;
        this.companyName = companyInfo?.alias || '';
        this.companyDetails = companyInfo;
        this.companyLogo = companyInfo?.logo?.dark || null;
        if (userInfo?.utm_source) {
          this.companyLogo = companyInfo?.logo?.alternateLogo || null;
        }
        if (this.mainMenu) {
          this.mainMenu.initStart();
        }
      });

    this.appState.connectionInfo.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res && Array.isArray(res) && res.length) {
        this.isSliderDisabled = res.length > 2;
        this.brandingInfo = res;
        setTimeout(() => {
          if (this.swiperCompRef && this.swiperCompRef.directiveRef) {
            if (res.length == 1) {
              this.isSingleBranded = true;
              this.swiperCompRef.config.slidesPerView = 1;
              this.swiperCompRef.config.slidesPerGroup = 1;
              this.swiperCompRef.config.autoplay = {};
              this.swiperCompRef.config.loop = false;
            }
            this.swiperCompRef.directiveRef.update();
            this.swiperCompRef.directiveRef.stopAutoplay();
          }
        });
      }
    });

    this.subscriptionService.isPlanActive.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        this.planExpired = false;
      } else {
        this.planExpired = true;
      }
    });

    this.showAllNavigation = this.storage.isProfileUpdated;
    if (this.appState.authTokenValue?.idToken) {
      this.updateUserInformation();
    }

    if (this.isProfilePicUpdated) {
      this.isProfilePicUpdated.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((isPicUrlUpdated) => {
        if (isPicUrlUpdated) {
          this.userProfileImg = this.userState.userDetails?.user_profile.profileImage;
        }
      });
    }

    if (this.isProfileUpdated) {
      this.isProfileUpdated.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((isProfileUpdated) => {
        this.showAllNavigation = isProfileUpdated;
        this.updateUserInformation();
      });
    }

    combineLatest([
      this.notificationState.notifications$,
      this.notificationService.userNotifications$,
    ])
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(([propertyNotifications, userNotifications]) => {
        const notifications = [
          ...(Array.isArray(propertyNotifications) ? propertyNotifications : []),
          ...(Array.isArray(userNotifications) ? userNotifications : []),
        ];

        this.notificationData =
          this.buildUnreadNotificationData(notifications);

        this.unreadNotificationCount =
          this.notificationData.length;

        this.updateNotificationBadgeCount();
        this.cdr.detectChanges();
      });

    this.subscriptionState.planUsage.pipe(takeUntil(this.onDestroyNotifier$)).subscribe(
      (res) => {
        if (res && Object.keys(res).length && this.appState.companyInfoValue?.appConfig?.planSubscription?.isEnabled) {
          this.getPlanUsageCount(res);
        }
      },
      (err) => {
        console.log('err:', err);
      }
    );

    this.userState.businessAreaList$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (!this.authorizeService.canView('businessArea')) {
        return false;
      }
      this.businessAreaAlertStatus = 0;
      if (res && !res.length) {
        this.businessAreaAlertStatus = 1;
      }
      this.updateNotificationBadgeCount();
      this.cdr.detectChanges();
    });

    this.userState.mlsList$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (!this.authorizeService.canView('mls')) {
        return false;
      }

      this.mlsAlertStatus = 0;
      if (res && !res.length) {
        this.mlsAlertStatus = 1;
      }

      this.updateNotificationBadgeCount();
      this.cdr.detectChanges();

      if (res && !res.length && this.appState.companyInfoValue.appConfig?.valueReport?.isEnabled) {
        if (this.userRole == 'appraiser' && !this.reportsState.mlsAddShown) {
          this.reportsState.mlsAddShown = true;
          this.openSnackbar('MLS not added!!', false);
          this.router.navigate(['profile'], { queryParams: { redirectTo: 'mls' } });
        }
      }
    });

    this.userState.userDetail$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res) => {
        if (!res) return;

        if (res?.roles?.includes('loanOfficer')) {
          if (res.id == this.appState.companyInfoValue?.defaultLoanOfficer) {
            this.isDefaultLoanOfficer = true;
          }
        }

        if (res?.roles?.includes('agent')) {
          if (res.id == this.appState.companyInfoValue?.defaultAgent) {
            this.isDefaultAgent = true;
          }
        }

        if (res?.user_profile?.contact) {
          this.userContact = true;
        }

        let userRole = res.roles[0];
        if (this.appState?.companyInfoValue?.appConfig?.chatBot?.isEnabled) {
          this.chatBotName = this.appState?.companyInfoValue?.appConfig?.chatBot?.botName || 'Rhea';
          if (this.appState?.companyInfoValue?.appConfig?.chatBot?.enabledRoles.includes(userRole)) {
            // this.router.url != '/workspace' && this.router.url != '/workspace/map' && 
            if (this.router.url != '/chat') {
              this.enableChatBot = true;
            } else {
              this.enableChatBot = false;
            }
          }
        }
        if (this.router.url.includes('/verifyAccount')) {
          this.enableChatBot = false;
        }
        this.cdr.detectChanges();
      });

    this.subscriptionState.planUpgrade.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((upgradeMsg) => {
      if (upgradeMsg) {
        this.message = upgradeMsg['message'];
        this.showModifySearchButton = upgradeMsg['showButton'];
        this.dialogRef = this.dialog.open(this.planUpdateDialog, {
          width: '400px',
        });
      }
    });

  this.updateSignInVisibility(this.router.url);
  // Check whenever Angular navigates to another route
  this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      this.updateSignInVisibility(event.urlAfterRedirects);
    });

        const pathname = window.location.pathname;
    if (pathname && pathname != '' && this.appState.companyInfoValue?.appConfig?.valueReport?.isEnabled) {
      let lPaths = pathname.split('/');
      if (lPaths && lPaths.length > 0 && lPaths[lPaths.length - 1] == 'shared') {
        this.viewSignIn = false;
      }
    }

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        const pathname = event.urlAfterRedirects;
        this.hideAttributes = this.pathsToHideAttributes.some((path) =>
          window.location.pathname.includes(path)
        );
        if (this.hideAttributes) {
          this._pktrAppMenuService.close(false);
        } else {
          if (this.userRole) {
            // this._pktrAppMenuService.open();
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener(
      'change',
      this.mobileQueryListener
    );

    this.clientDarkLogo = null;
    this.companyLogo = null;
    this.companyDetails = {};

    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();

    this.alertList$.unsubscribe();
    this.planUsage$.unsubscribe();
    this.alertListCount$.unsubscribe();
    this.initialLoginSub$.unsubscribe();
  }

  navigateToUsers() {
    this.router.navigate(['/users']);
  }

  get hasCmaBundle(): boolean {
    const bundles = this.planStats?.activeBundles || [];

    return bundles.some(
      (b: any) =>
        b.bundleCode === 'cma_bundle_c' ||
        b.planName?.toLowerCase().includes('cma')
    );
  }

  get hasAnyBundles(): boolean {
    const bundles = this.planStats?.activeBundles || [];
    return bundles.length > 0;
  }

  getPlanUsageCount(res: any) {
    if (res?.isTrial && res?.renewalDate) {
      const remainingDays = Math.round(
        moment(res.renewalDate).diff(moment(new Date()), 'days', true)
      );
      this.planExpiryDate = remainingDays;
    } else {
      this.planExpiryDate = null;
    }

    this.isTrial = !!res?.isTrial && !res?.trialExpired;
    this.isLandingPlan = !!res?.isLandingPlan;
    this.showUpgrade = this.isTrial || this.isLandingPlan;

    this.planStats = res;

    const countDisplayFeature =
      this.appState.companyInfoValue?.appConfig?.planSubscription?.countDisplayFeature;

    if (
      !this.isTrial &&
      countDisplayFeature &&
      res?.featureList?.[countDisplayFeature]?.usageLimit > 0
    ) {
      this.maxUsageLimit = res.featureList[countDisplayFeature].usageLimit;

      const consumableRemaining = res?.consumableRemaining;
      let consumablesRemainingValue = 0;

      if (
        consumableRemaining &&
        consumableRemaining[countDisplayFeature] !== undefined &&
        consumableRemaining[countDisplayFeature] >= 0
      ) {
        consumablesRemainingValue = consumableRemaining[countDisplayFeature];
      }

      this.alreadyUsedLimit = this.maxUsageLimit - consumablesRemainingValue;

      if (this.alreadyUsedLimit > this.maxUsageLimit) {
        this.alreadyUsedLimit = this.maxUsageLimit;
      }

      if (this.alreadyUsedLimit < 0) {
        this.alreadyUsedLimit = 0;
      }
    } else {
      this.maxUsageLimit = null;
      this.alreadyUsedLimit = 0;
    }

    this.cdr.detectChanges();
  }

  userLogout() {
    this.prospektrApi
      .logOutUser()
      .pipe(
        takeUntil(this.onDestroyNotifier$),
        finalize(() => {
          localStorage.clear();
          sessionStorage.clear();
          this.appState.authTokenValue = null;
          this.appState.clientInfoSubValue = {
            client: {
              logo: {
                light: constants.lightLogo,
                dark: constants.darkLogo,
              },
              appTheme: {
                primaryColor: constants.appPrimaryColor,
                secondaryColor: constants.appSecondaryColor,
              },
              name: constants.APPLICATION_NAME,
            },
            user: null,
          };
          this.notificationService.destroyRealtimeNotifications();
          this.socketService.disconnect();
          this.appState.partnerInfoValue = {};
          if (this.appState.companyInfoValue?.alias === 'valuetest') {
            window.location.href = 'signup';
          }
          // else if (this.appState.companyInfoValue?.alias === 'opscan') {
          //   window.location.href = 'login';
          // } 
          else {
            window.location.href = 'workspace';
          }
        })
      )
      .subscribe();
  }

  updateUserInformation() {
    this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        this.userProfileImg = res.user_profile.profileImage;
        this.userProfileImg = res.user_profile.profileImage;
        const firstName = res.user_profile.firstName;
        const lastName = res.user_profile.lastName;
        this.userName = firstName + ' ' + lastName;
      }
    });
  }

  navigationEvent(navigationPath) {
    this.navEvent.next(navigationPath);
  }

  upgrade() {
    this.closeDialog();
    this.subscriptionState.closeSideNav = true;
    this.appState.navigatedFrom = this.router.url;
    this.router.navigate(['/profile'], {
      queryParams: {
        redirectTo: 'payment',
      },
      replaceUrl: true,
      state: { skipUpdate: true }
    });
  }

  goToBusinessArea() {
    this.appState.navigatedFrom = this.router.url;
    this.router.navigate(['/profile'], {
      queryParams: {
        redirectTo: 'businessArea',
      },
    });
  }

  goToMls() {
    this.appState.navigatedFrom = this.router.url;
    this.router.navigate(['/profile'], {
      queryParams: {
        redirectTo: 'mls',
      },
    });
  }

  openLogInDialog() {
    if (this.appState.companyInfoValue?.alias === 'valuetest') {
      this.router.navigate(['/signup']);
    } else if (this.appState.companyInfoValue?.alias === 'opscan') {
      this.router.navigate(['/login']);
    } else if (this.appState.companyInfoValue?.alias === 'rubyporch') {
      this.router.navigate(['/login']);
    } else {
      this.authorizeService.openLogInDialog();
    }
  }

  redirectToProfile() {
    this.appState.navigatedFrom = this.router.url;
    this.router.navigate(['/profile']);
  }

  redirect(flag) {
    if (flag === 'sell') {
      this.router.navigate(['/listMyHome']);
      this.showInvestSell = false;
      this.showInvest = true;

    } else {
      this.router.navigate(['/workspace/map']);
      this.showInvestSell = true;
      this.showInvest = false;
    }
  }

  closeDialog() {
    this.subscriptionState.planUpgradeMessage = null;
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  openSnackbar(upgradeMsg, success = false) {
    this.upgradeSnackbar = this.snackbar.open(upgradeMsg, 'Dismiss', {
      duration: 3000,
      panelClass: [success ? 'snackbar-success' : 'snackbar-error'],
      verticalPosition: 'top',
    });
  }

  routeToChat() {
    if (!this.subscriptionService.checkFeatureValidity(constants.PLAN_BASED_FEATURES.chatBot.key)) return;

    this.router.navigate(['chat']);
  }

  showAllNotifications() {
    this.router.navigate(['/notification']);
  }

  openNotification(notification: AppNotification | any): void {
    const actionUrl =
      notification?.actionUrl ||
      notification?.route ||
      notification?.data?.route;

    if (actionUrl) {
      this.router.navigateByUrl(actionUrl);
      return;
    }

    this.router.navigate(['/notification']);
  }

  private buildUnreadNotificationData(
    notifications: any[]
  ): any[] {
    const notificationData: any[] = [];
    const safeNotifications = Array.isArray(notifications)
      ? notifications
      : [];

    safeNotifications.forEach((notification: any) => {
      /*
       * Existing property-monitoring notification.
       */
      if (Array.isArray(notification.notificationList)) {
        const latestByReferenceType =
          new Map<string, any>();

        notification.notificationList.forEach(
          (notificationItem: any) => {
            if (
              !notificationItem ||
              !notificationItem.referenceType
            ) {
              return;
            }

            const existingItem = latestByReferenceType.get(
              notificationItem.referenceType
            );

            const existingTime = this.getNotificationTime(
              existingItem
            );

            const currentTime = this.getNotificationTime(
              notificationItem
            );

            if (
              !existingItem ||
              currentTime >= existingTime
            ) {
              latestByReferenceType.set(
                notificationItem.referenceType,
                notificationItem
              );
            }
          }
        );

        Array.from(latestByReferenceType.values())
          .filter(
            (notificationItem: any) =>
              notificationItem.readStatus === false
          )
          .forEach((notificationItem: any) => {
            notificationData.push({
              id:
                notificationItem.referenceId ||
                notification._id,
              sourceId: notification._id,
              notificationType: 'property',
              address: notification.address || '',
              referenceType:
                notificationItem.referenceType,
              notificationMessage:
                notificationItem.displayText ||
                'Property notification',
              readStatus:
                notificationItem.readStatus,
              createdDate:
                notificationItem.createdDate,
            });
          });

        return;
      }

      /*
       * General notification format.
       */
      const isUnread =
        notification.readStatus === false ||
        notification.isRead === false ||
        notification.status === 'unread';

      if (!isUnread) {
        return;
      }

      notificationData.push({
        id:
          notification.data?.referenceId ||
          notification.id ||
          notification.notificationId ||
          notification._id,
        sourceId:
          notification.id ||
          notification.notificationId ||
          notification._id,
        notificationType:
          notification.category ||
          notification.type ||
          'general',
        category: notification.category || 'general',
        type: notification.type,
        status: notification.status,
        address:
          notification.reportName ||
          notification.address ||
          '',
        referenceType:
          notification.referenceType ||
          notification.type ||
          'general',
        notificationMessage:
          notification.notificationMessage ||
          notification.message ||
          notification.title ||
          'New notification',
        readStatus: false,
        createdDate:
          notification.createdDate ||
          notification.createdAt,
        actionUrl:
          notification.actionUrl ||
          notification.route ||
          notification.data?.route ||
          '/notification',
        reportId: notification.reportId,
        reportReferenceId:
          notification.reportReferenceId,
        reportName: notification.reportName,
        failureReason: notification.failureReason,
        icon: notification.icon,
      });
    });

    const deduplicatedNotifications = Array.from(
      new Map(
        notificationData.map((notification) => [
          `${notification.notificationType}:${notification.id}`,
          notification,
        ])
      ).values()
    );

    return this.notificationService
      .formatAlerts(deduplicatedNotifications)
      .sort(
        (first, second) =>
          this.getNotificationTime(second) -
          this.getNotificationTime(first)
      );
  }

  private getNotificationTime(notification: any): number {
    if (!notification) {
      return 0;
    }

    const date =
      notification.createdDate ||
      notification.createdAt;

    if (!date) {
      return 0;
    }

    const timestamp = new Date(date).getTime();

    return Number.isNaN(timestamp) ? 0 : timestamp;
  }

  private updateNotificationBadgeCount(): void {
    this.notificationCount =
      this.unreadNotificationCount +
      this.businessAreaAlertStatus +
      this.mlsAlertStatus;
  }
  private updateDisplayInfo(url: string) {
    const pathname = url.split('?')[0];
    this.displayInfo = pathname.split('/')[1] === 'workspace';
  }

  updateSignInVisibility(url: string): void {
  this.viewSignIn = !url.includes('/info/requestStatus');
}

}
